var styles = {"box":"Wrapper_box_1sad8_1","box__inner":"Wrapper_box__inner_1sad8_62","transparent":"Wrapper_transparent_1sad8_66","left":"Wrapper_left_1sad8_66","right__image":"Wrapper_right__image_1sad8_124","right__content":"Wrapper_right__content_1sad8_130","right":"Wrapper_right_1sad8_124","close":"Wrapper_close_1sad8_134"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
